import React, { useState } from 'react';
import { useRoles } from '../../hooks/useRoles';
import FeatureManagement from './FeatureManagement';
import './Admin.css';

const SystemManagement = () => {
  const { userProfile } = useRoles();
  const [activeSection, setActiveSection] = useState(null);

  const isSuperAdmin = userProfile?.roles?.includes('SuperAdmin');

  if (!isSuperAdmin) {
    return (
      <div className="admin-page">
        <div className="card text-center py-12">
          <div className="icon-container gray">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 002 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-700 mb-2">Access Restricted</h3>
          <p className="text-gray-500 mb-2">You do not have permission to access system management.</p>
          <p className="text-sm text-gray-400">Contact your administrator for access.</p>
        </div>
      </div>
    );
  }

  if (activeSection === 'features') {
    return <FeatureManagement onBack={() => setActiveSection(null)} />;
  }

  return (
    <div className="admin-page">
      <div className="reporting-header mb-6">
        <div className="flex flex-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h2 className="text-2xl font-semibold text-gray-800">System Management</h2>
              <div className="role-badge super-admin">Super Admin Access</div>
            </div>
            <p className="text-gray-600">
              Configure and manage system-wide settings and features.
            </p>
          </div>
        </div>
      </div>

      <div className="reports-overview mb-8">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Management Areas</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

          {/* Feature Management */}
          <div
            className="report-card card cursor-pointer hover:bg-purple-50 transition-colors"
            onClick={() => setActiveSection('features')}
          >
            <div className="report-icon-container">
              <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-gray-800 mb-2">Feature Management</h4>
            <p className="text-sm text-gray-600 mb-4">
              Control feature flags and system-wide feature availability.
            </p>
            <div className="report-meta text-xs text-gray-500">Manage the feature registry</div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SystemManagement;
